var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 12,
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20552_18232)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  transform: "translate(0.5)",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.49643 0.625977C6.63917 0.625977 6.76953 0.707014 6.83271 0.835016L8.28842 3.78464L11.5432 4.25635C11.6846 4.27684 11.802 4.37582 11.8461 4.51165C11.8902 4.64748 11.8533 4.79658 11.751 4.89619L9.39239 7.19206L9.94853 10.4341C9.97268 10.5748 9.91478 10.7171 9.79921 10.801C9.68363 10.8848 9.53045 10.8958 9.40411 10.8292L6.49973 9.29875L3.58844 10.8294C3.46209 10.8958 3.30899 10.8848 3.19351 10.8009C3.07803 10.717 3.02019 10.5748 3.04433 10.4341L3.60047 7.19206L1.24186 4.89619C1.13953 4.79658 1.10265 4.64748 1.14676 4.51165C1.19087 4.37582 1.30831 4.27684 1.44964 4.25635L4.70444 3.78464L6.16015 0.835016C6.22332 0.707014 6.35369 0.625977 6.49643 0.625977Z",
  fill: "#079D56",
  stroke: "#079D56",
  strokeLinecap: "square",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20552_18232"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white",
  transform: "translate(0.5)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star.dcd9267f579422911c2fa7d53b2cb885.svg";